// © Microsoft Corporation. All rights reserved.

import { ActivityData, User } from "@msnews/social-data-service";
import { TelemetryEventMap, dispatchTelemetryEvent } from "../../Social.telemetry";
import { check_small, exclamation_small } from "../../utils/icons";

import ProfileActivityReadMarker from "./ProfileActivityReadMarker";
import React from "react";
import { SocialClassNameContract } from "../../Social.classnames";
import { SocialLocalizedStrings } from "../../Social.localizedStrings";
import { SocialState } from "../../Social.state";
import { UsersConnector } from "../../Social.props";
import { classNames } from "@microsoft/fast-web-utilities";
import { connect } from "react-redux";
import { enums } from "../../utils/enums";
import getAgoText from "../../utils/getAgoText";
import { hasThemeBase } from "../../utils/themeHelpers";

export interface ProfileAlertActivityProps {
    activity: ActivityData;
    managedClasses: SocialClassNameContract;
    t: SocialLocalizedStrings;
    me: User;
    usersConnector: UsersConnector;
    checkIcon?: boolean;
    theme?: string;
    responsiveClass: string;
}

const mapStateToProps = function(state: SocialState) {
    return {
        theme: state.theme
    };
};

export class ProfileAlertActivity extends React.Component<ProfileAlertActivityProps> {
    activityItemRef: React.RefObject<HTMLLIElement>;
    isLoaded: boolean;

    constructor(props) {
        super(props);

        this.activityItemRef = React.createRef();
    }

    componentDidMount() {
        if (this.activityItemRef && this.activityItemRef.current) {
            dispatchTelemetryEvent(TelemetryEventMap.genericLoaded, this.activityItemRef.current);
        }

        this.loadedHandler();
    }

    componentDidUpdate() {
        this.loadedHandler();
    }

    render() {
        const { responsiveClass, children, activity, managedClasses, usersConnector, checkIcon, theme } = this.props;
        const isSuperApp = hasThemeBase(theme, enums.theme.superappBase);
        return (
            <li
                key={activity.id.toString()}
                ref={this.activityItemRef}
                className={classNames(
                    managedClasses.profileActivityContainer,
                    managedClasses.profileActivityAlertContainer,
                    !activity.isSeen ? "new" : "",
                    [managedClasses.profileActivitySuperAppContainer, isSuperApp],
                    responsiveClass
                )}
            >
                {this.activityItemRef.current && <ProfileActivityReadMarker {...{activity, usersConnector, activityItemRef: this.activityItemRef.current}} />}
                <div className="cwt-start">
                    <i className={`cwt-icon cwt-alert-icon ${ checkIcon ? "cwt-check-icon" : "" }`}>
                        {checkIcon ? check_small : exclamation_small}
                    </i>
                </div>
                <div className="cwt-mid">
                    <div className="cwt-text"> { activity.message } </div>

                    { children }

                    <div className="cwt-sub-text"> {getAgoText(activity.datetime)} </div>
                </div>
                <div className="cwt-end"></div>
            </li>
        );
    }

    loadedHandler() {
        if (this.isLoaded) { return; }

        if (this.activityItemRef && this.activityItemRef.current) {
            dispatchTelemetryEvent({...TelemetryEventMap.genericLoaded, sendPeregrine: true}, this.activityItemRef.current);
            this.isLoaded = true;
        }
    }
}

export default connect(mapStateToProps)(ProfileAlertActivity);